import * as React from 'react'

import ModalComponent from './Modal'

export const Modal = () => <ModalComponent />
